import * as React from 'react'

import Avatar from '~/client/components/Avatar'
import color from '../media/logo/datapal-app-icon-full-color-rgb.svg'
import white from '../media/logo/datapal-logo-mark-white-rgb.svg'

const VARIANTS = { white, color }

export default function DataPalLogo({
  variant = 'color',
  ...props
}){
  return <Avatar
    src={VARIANTS[variant]}
    {...props}
  />
}
